<div class="meter" [ngClass]="getClass()" [style.width]="getWidth()">
  <div class="section"></div>
</div>